<template>
<div class="comments-container my-3" v-if="enable == '1'">
    <div class="fb-comments" :data-colorscheme="colorsheme" :data-mobile="mobile" :data-width="width" :data-href="url" :data-numposts="numposts" :data-order-by="orderBy"></div>
</div>
</template>
<script>
export default {
    name: "fb-comment",
    props: {
        url: {
            type: String
        },
        enable: {
            type: String,
            default: '1'
        },
        mobile: {
            type: Boolean,
            default: true
        },
        numposts: {
            type: String,
            default: '10'
        },
        orderBy: {
            type: String,
            default: "social"
        },
        width: {
            type: String,
            default: "100%"
        },
        colorsheme: {
            type: String,
            default: 'light'
        }
    }
}
</script>
